import { ContentTitlePreview } from "@/src/components/ContentLitstItem";
import { AHSeparator, Box, AHText } from "arkh";
import React, { useMemo } from "react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoEditNewMainOrgTitleAndDescription_todo$key } from "./__generated__/TodoEditNewMainOrgTitleAndDescription_todo.graphql";
import { RichTextViewer } from "@/src/components/RichText";

export function TodoEditNewMainOrgTitleAndDescription(props: {
  todo: TodoEditNewMainOrgTitleAndDescription_todo$key;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoEditNewMainOrgTitleAndDescription_todo on Todo {
        title
        body
        formattedBody
      }
    `,
    props.todo
  );

  const hasFormattedBody = useMemo(() => {
    return (
      todo.formattedBody &&
      todo.formattedBody.length > 0 &&
      todo.formattedBody !== '{"type":"doc","content":[{"type":"paragraph"}]}'
    );
  }, [todo.formattedBody]);

  return (
    <Box spaceBottom="medium">
      <ContentTitlePreview title={todo.title} />

      <AHSeparator />

      {hasFormattedBody ? (
        <Box space="medium" spaceBottom="none">
          <RichTextViewer data={todo.formattedBody} />
        </Box>
      ) : todo.body ? (
        <AHText space="medium" spaceBottom="none" type="body-big">
          {todo.body}
        </AHText>
      ) : null}
    </Box>
  );
}
